import { useEffect } from 'react';

import { Fn, Predicate } from '@/types/common';

type UseObserverConfig = {
  onObserve: Fn<IntersectionObserverEntry, void>;
  beforeApplyObserver?: {
    predicate: Predicate<Element[]>;
    transform: Fn<Element, Element>;
  };
  observableElements: NodeListOf<Element>;
  observerConfig?: IntersectionObserverInit;
  shouldSkip?: boolean;
};
export const useObserver = ({
  observableElements,
  beforeApplyObserver,
  onObserve,
  observerConfig,
  shouldSkip,
}: UseObserverConfig) => {
  useEffect(() => {
    if (shouldSkip) return;
    const { predicate, transform } = beforeApplyObserver || {};

    const handleIntersections: IntersectionObserverCallback = entries => {
      entries.forEach(onObserve);
    };

    const observer = new IntersectionObserver(handleIntersections, observerConfig);

    observableElements.forEach(elem => {
      if (predicate) {
        if (predicate(elem)) {
          if (transform) {
            return observer.observe(transform(elem));
          }
          return observer.observe(elem);
        }

        return;
      }

      if (transform) {
        return observer.observe(transform(elem));
      }
      return observer.observe(elem);
    });
    return () => {
      observer.disconnect();
    };
  }, [observableElements, shouldSkip, observerConfig]);
};
